<template>
  <div>
    <Confirm
      v-if="!successDialog"
      :dialog="value"
      :loading="loading"
      :title="$t('patients.invite.title')"
      :text="$t('patients.invite.text')"
      :confirmText="$t('patients.invite.button')"
      :cancelText="$t('general.dialog.cancel')"
      @toggleDialog="toggleDialog"
      @confirm="submitInvite"
    >
      <v-container class="no-padding-bottom no-padding-top">
        <v-row>
          <v-col cols="6" class="no-padding-bottom">
            <BaseInput
              v-model="firstName"
              :errors="firsNameErrors"
              :placeholder="$t('general.inputs.firstName')"
              @blur="$v.firstName.$touch()"
              @change="onFirstNameChange"
          /></v-col>
          <v-col cols="6" class="no-padding-bottom">
            <BaseInput
              v-model="lastName"
              :errors="lastNameErrors"
              :placeholder="$t('general.inputs.lastName')"
              @blur="$v.lastName.$touch()"
              @change="onLastNameChange"
          /></v-col>
        </v-row>
        <BaseInput
          v-model="email"
          :errors="emailErrors"
          :placeholder="$t('general.inputs.email')"
          @blur="$v.email.$touch()"
          @change="onEmailChange"
        />
        <Select v-model="locale" :items="languages" :label="$t('settings.selectLanguage')" />
      </v-container>
    </Confirm>
    <SuccessDialog :dialog="successDialog" :text="$t(`patients.invite.success`)" @on-close="successDialog = false" />
  </div>
</template>
<script>
import { alpha, email, required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

import Confirm from "@/components/shared/Confirm";
import SuccessDialog from "@/components/shared/SuccessDialog";
import BaseInput from "@/components/uikit/BaseInput";
import Select from "@/components/uikit/Select";
import { LANGUAGES } from "@/utils/languages";

import { snackBarEventBus, snackBarEventName } from "../../eventBuses/snackBar.eventBus";

export default {
  name: "InvitePatientDialog",
  props: ["value"],
  components: {
    Confirm,
    BaseInput,
    Select,
    SuccessDialog,
  },
  data: () => ({
    successDialog: false,
    email: "",
    firstName: "",
    lastName: "",
    locale: "",
    loading: false,
    languages: LANGUAGES,
  }),
  validations: {
    email: { required, email },
    firstName: { required, alpha },
    lastName: { required, alpha },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push(this.$t("validation.email"));
      !this.$v.email.required &&
        errors.push(this.$t("validation.required", { field: this.$t("general.inputs.email") }));
      return errors;
    },
    firsNameErrors() {
      const errors = [];
      if (!this.$v.firstName.$dirty) return errors;
      !this.$v.firstName.alpha && errors.push(this.$t("validation.name"));
      !this.$v.firstName.required &&
        errors.push(this.$t("validation.required", { field: this.$t("general.inputs.firstName") }));
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastName.$dirty) return errors;
      !this.$v.lastName.alpha && errors.push(this.$t("validation.name"));
      !this.$v.lastName.required &&
        errors.push(this.$t("validation.required", { field: this.$t("general.inputs.lastName") }));
      return errors;
    },
  },
  methods: {
    ...mapActions("invites", ["sendInvite", "getAllInvites"]),
    toggleDialog() {
      this.$emit("toggleDialog");
    },
    toggleSuccessDialog() {
      this.successDialog = !this.successDialog;
    },
    onFirstNameChange(value) {
      this.firstName = value;
    },
    onLastNameChange(value) {
      this.lastName = value;
    },
    onEmailChange(value) {
      this.email = value;
    },
    clearFields() {
      this.email = "";
      this.firstName = "";
      this.lastName = "";
    },
    async submitInvite() {
      this.$gtag.event("click", { method: "Submit Patient Invite" });
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      try {
        this.loading = true;
        await this.sendInvite({
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName,
          locale: this.locale,
        });
        this.toggleDialog();
        this.toggleSuccessDialog();
        await this.getAllInvites();
        this.clearFields();
        this.$emit("success");
      } catch (err) {
        snackBarEventBus.$emit(snackBarEventName, { message: err.message || err, type: "error" });
      }
      this.loading = false;
    },
  },
};
</script>
